// extracted by mini-css-extract-plugin
export default {"card-bank":"CardBankPayout_card-bank__nnqrg","field-account":"CardBankPayout_field-account__hvU3Z","info-bank":"CardBankPayout_info-bank__B3kxU","icon":"CardBankPayout_icon__3xI7L"};